import { render, staticRenderFns } from "./menu-layout.vue?vue&type=template&id=6e04e252&scoped=true"
import script from "./menu-layout.vue?vue&type=script&lang=js"
export * from "./menu-layout.vue?vue&type=script&lang=js"
import style0 from "./menu-layout.vue?vue&type=style&index=0&id=6e04e252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04e252",
  null
  
)

export default component.exports